
function AdventPolicy() {
  return (<div className="container">
    <h2>Privacy Policy for <span className="App-title">Calendrier de l'Advent</span></h2>

    <p>Last updated:  Octobre 10th, 2026</p>
    <p>
      Welcome to <span className="App-title">Calendrier de l'Advent</span>  ("we," "our," or "us"). We are committed to protecting your privacy. This Privacy Policy
      explains how we collect, use, disclose, and safeguard your information when you use our game app, <span className="App-title">Calendrier de l'Advent</span>
      ("the App"). By using the App, you agree to the collection and use of information in accordance with this policy.
    </p>
    <h2>1. Information We Collect</h2>
    <p>     We may collect the following types of information:</p>

    <h3>1.1 Personal Information</h3>
    <p>We may collect limited personal information that you voluntarily provide to us, such as:

      Name and email address (e.g., when you sign up for an account or contact us for support).</p>
    <h3>1.2 Usage Data</h3>
    <p>      When you use the App, we may collect data automatically, including but not limited to:

      Device information (e.g., device model, operating system, unique device identifier).
      App usage data (e.g., in-game activity, levels completed, in-game purchases).
      IP address and game settings.</p>
    <h3>1.3 Cookies and Tracking Technologies</h3>
    <p>We may use cookies and similar tracking technologies to monitor activity on the App and retain certain information. You
      can control the use of cookies at the individual browser level, but if you choose to disable cookies, it may affect your
      use of the App.</p>

    <h2>2. How We Use Your Information</h2>
    <p> We don't collected information.</p>
    <h2>3. Sharing Your Information</h2>
    <p>We may share your information with:</p>
    <ul>
      <li><strong>Service Providers:</strong> Third-party companies we work with to assist us in operating and maintaining the App (e.g., analytics providers, payment processors).</li>
      <li><strong>Legal Requirements:</strong> When required by law or to protect our rights, users, or the public.</li>
    </ul>
    <p>We do not sell, trade, or rent your personal information to others.</p>

    <h2>4. Data Security</h2>
    <p>We use appropriate security measures to protect your data from unauthorized access, disclosure, alteration, or
      destruction. However, please be aware that no method of transmission over the internet or method of electronic storage
      is 100% secure, and we cannot guarantee absolute security.</p>

    <h2>5. Third-Party Services</h2>
    <p>Our App may contain links to third-party services or be integrated with services such as advertising or analytics. These
      services operate independently of us and are governed by their own privacy policies. We are not responsible for the
      content or practices of any third-party services.</p>

    <h2>6. Children’s Privacy</h2>
    <p>Our App is not intended for use by children under the age of 13, and we do not knowingly collect personal information
      from children under 13. If we become aware that a child under 13 has provided us with personal information, we will
      delete such information immediately.</p>

    <h2>7. Changes to This Privacy Policy</h2>
    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy
      on this page and updating the "Last Updated" date. You are advised to review this Privacy Policy periodically for any
      changes.</p>

    <h2>8. Contact Us</h2>
    <p> If you have any questions about this Privacy Policy, please contact us at:</p>

    <p>Email: tryciaspas at gmail dot com</p>

  </div>);
}
export default AdventPolicy;
